module.exports = function (breakpointsService, $state, $rootScope, $stateParams, searchService, shopPageStateService, settingsService, moveFocus, featureService, multisearchService) {
    return {
        restrict: 'E',
        scope: {
            getCounts: '=',
            disableNavigationLinks: '='
        },
        link(scope) {
            scope.search = searchService;
            scope.categories = [];
            scope.isSearchShowCategory = true;

            if (scope.getCounts) {
                searchService.getCounts($stateParams.searchTerm, multisearchService.isSearchMultisearch());
            }

            scope.setupMultisearch = function () {
                if (!breakpointsService.isInSmallFormat && multisearchService.isSearchMultisearch()) {
                    // remove the currently active search item from the list
                    const items = $stateParams.multisearchItems.split(',');
                    scope.multisearchNavigationItems = items;
                    scope.isMultisearch = true;
                } else {
                    scope.multisearchNavigationItems = [];
                    scope.isMultisearch = false;
                }
            };

            scope.multisearchMedLargeSettingOn = featureService.isEnabled(featureService.features.multisearch);
            scope.setupMultisearch();

            function updateCategories() {
                if (searchService.categories && searchService.categories.length > 0) {
                    scope.categories = searchService.categories;
                } else {
                    scope.categories = [];
                }
            }

            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                scope.isSmallFormatCentrePanelSlideEnabled = setting;
            });

            settingsService.getSettingValue('OneSite', 'SearchShowCategories').then(function (enabled) {
                scope.isSearchShowCategory = enabled;
                if (!scope.isSmallFormatCentrePanelSlideEnabled && breakpointsService.isInSmallFormat) {
                    scope.isSearchShowCategory = false;
                }
            });

            scope.dontShowCategories = function () {
                return $state.includes('shop.search.articles') || $state.includes('shop.search.recipes') || $state.includes('shop.search.zero-result') || searchService.categories.length < 1 || !scope.isSearchShowCategory || (!scope.isSmallFormatCentrePanelSlideEnabled && breakpointsService.isInSmallFormat);
            };

            const goToState = function (state, params) {
                if ($state.$current.name === state) {
                    $state.forceReload();
                } else {
                    $state.go(state, params);
                }
            };

            function shouldReloadCentrePanel() {
                return $state.includes('shop.search.products') || $state.includes('shop.search.specials') || $state.includes('shop.search.zero-result');
            }


            function refresh() {
                searchService.getSearchCounts($stateParams.searchTerm, multisearchService.isSearchMultisearch()).then(function () {
                    if (shouldReloadCentrePanel()) {
                        searchService.resetPrevious();
                        const nextState = searchService.determineStateToShow($stateParams.searchTerm);
                        goToState(nextState.name, nextState.params);
                    }
                });
            }

            scope.$on('address-update', function () {
                if ($state.includes('shop.search.articles') || $state.includes('shop.search.recipes')) {
                    searchService.getSearchCounts($stateParams.searchTerm, multisearchService.isSearchMultisearch());
                }
            });

            scope.$on('login:success', function () {
                refresh();
            });
            if (breakpointsService.isInSmallFormat) {
                shopPageStateService.triggerPanel('left', true);
            } else {
                moveFocus('#center-panel');
            }
            scope.$watch('search.categories', updateCategories);
            scope.$on('window:resize', scope.setupMultisearch);
        },
        template: require('./search-navigation-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-navigation-directive.js
 **/